import { useEffect, useMemo, useRef, useState } from 'react';

// 외부 라이브러리 없이 큐레이션된 이모지 그리드
const EMOJIS = [
  '📄', '📝', '📌', '📁', '📊', '✅', '💡', '🚀',
  '🎯', '🔥', '⭐', '📅', '📈', '🧩', '🗂️', '🎨',
  '🎬', '🛠️', '📣', '🧠', '📚', '🔖', '📋', '🗒️',
  '💼', '🏷️', '🔍', '⚙️', '🔔', '💬', '📞', '✉️',
  '🌟', '⚡', '🎉', '🏆', '💎', '🧪', '🔬', '🧭',
  '🗺️', '📦', '🛒', '💰', '📐', '✏️', '🖋️', '📎',
  '🔗', '🏠', '🌐', '🤝', '👥', '🙌', '👀', '❤️',
];

// 검색용 간단 키워드 매핑(선택 — 일부만)
const KEYWORDS = {
  '📄': '문서 파일 페이지 document file',
  '📝': '메모 노트 작성 note write',
  '📌': '핀 고정 pin',
  '📁': '폴더 folder',
  '📊': '차트 그래프 통계 chart',
  '✅': '체크 완료 done check',
  '💡': '아이디어 idea bulb',
  '🚀': '로켓 출시 launch rocket',
  '🎯': '목표 타겟 target goal',
  '🔥': '불 핫 fire hot',
  '⭐': '별 즐겨찾기 star',
  '📅': '달력 일정 calendar',
  '📈': '증가 성장 growth',
  '🧩': '퍼즐 조각 puzzle',
  '🗂️': '서류함 분류 folder',
  '🎨': '디자인 아트 design art',
  '🎬': '영상 영화 video film',
  '🛠️': '도구 설정 tool',
  '📣': '공지 알림 announce',
  '🧠': '브레인 생각 brain',
  '📚': '책 학습 book',
  '🔖': '북마크 bookmark',
  '💼': '업무 비즈니스 work business',
  '🔍': '검색 돋보기 search',
  '⚙️': '설정 톱니 settings',
  '🔔': '알림 종 bell',
  '💬': '대화 채팅 chat',
  '✉️': '메일 편지 mail',
  '🏆': '트로피 우승 trophy',
  '💎': '다이아 보석 gem',
  '🧪': '실험 테스트 test',
  '🔬': '연구 현미경 research',
  '🧭': '나침반 방향 compass',
  '🗺️': '지도 map',
  '📦': '박스 패키지 package',
  '💰': '돈 비용 money',
  '🔗': '링크 연결 link',
  '🏠': '홈 집 home',
  '🌐': '글로벌 웹 global web',
  '🤝': '협업 악수 partner',
  '👥': '팀 사람 team',
  '❤️': '하트 좋아요 heart',
};

export default function IconPicker({ value, onSelect, onClose }) {
  const [q, setQ] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    function onDoc(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    }
    function onKey(e) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('mousedown', onDoc);
    window.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);

  const list = useMemo(() => {
    const term = q.trim().toLowerCase();
    if (!term) return EMOJIS;
    return EMOJIS.filter((e) => {
      if (e.includes(term)) return true;
      const kw = KEYWORDS[e] || '';
      return kw.toLowerCase().includes(term);
    });
  }, [q]);

  return (
    <div className="pe-popover pe-icon-popover" ref={ref} role="dialog" aria-label="아이콘 선택">
      <div className="pe-popover-head">
        <input
          className="pe-popover-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="이모지 검색"
          autoFocus
          spellCheck={false}
        />
        {value ? (
          <button type="button" className="pe-popover-clear" onClick={() => onSelect(null)}>
            제거
          </button>
        ) : null}
      </div>
      <div className="pe-emoji-grid">
        {list.map((e) => (
          <button
            key={e}
            type="button"
            className={`pe-emoji-btn${e === value ? ' is-active' : ''}`}
            onClick={() => onSelect(e)}
            title={e}
          >
            {e}
          </button>
        ))}
        {list.length === 0 ? <div className="pe-popover-empty">결과 없음</div> : null}
      </div>
    </div>
  );
}
